/* =============================================================
   JCB Locations Map — interactive logic (no type split)
   ============================================================= */
(function () {
  'use strict';

  // pozycje labelek województw w viewBox 612x612 (centroidy)
  var LABEL_POSITIONS = {
    'zachodniopomorskie': { x: 95, y: 147, name: 'Zach.-Pomorskie' },
    'pomorskie': { x: 239, y: 93, name: 'Pomorskie' },
    'warminsko-mazurskie': { x: 405, y: 122, name: 'Warm.-Mazurskie' },
    'podlaskie': { x: 529, y: 178, name: 'Podlaskie' },
    'lubuskie': { x: 83, y: 280, name: 'Lubuskie' },
    'wielkopolskie': { x: 195, y: 267, name: 'Wielkopolskie' },
    'kujawsko-pomorskie': { x: 268, y: 196, name: 'Kuj.-Pomorskie' },
    'mazowieckie': { x: 421, y: 265, name: 'Mazowieckie' },
    'lubelskie': { x: 527, y: 373, name: 'Lubelskie' },
    'dolnoslaskie': { x: 146, y: 385, name: 'Dolnośląskie' },
    'opolskie': { x: 229, y: 427, name: 'Opolskie' },
    'lodzkie': { x: 323, y: 336, name: 'Łódzkie' },
    'swietokrzyskie': { x: 402, y: 416, name: 'Świętokrzyskie' },
    'slaskie': { x: 298, y: 457, name: 'Śląskie' },
    'malopolskie': { x: 373, y: 502, name: 'Małopolskie' },
    'podkarpackie': { x: 484, y: 493, name: 'Podkarpackie' }
  };

  var SVG_NS = 'http://www.w3.org/2000/svg';

  function init(root) {
    if (root.dataset.jcbInitialized === '1') return;
    root.dataset.jcbInitialized = '1';

    var dataUrl = root.dataset.dataUrl;
    var listEl = root.querySelector('[data-jcb-list]');
    var emptyEl = root.querySelector('[data-jcb-empty]');
    var searchEl = root.querySelector('[data-jcb-search]');
    var totalEl = root.querySelector('[data-jcb-total]');
    var hintEl = root.querySelector('[data-jcb-hint]');
    var voivStatusEl = root.querySelector('[data-jcb-voiv-status]');
    var voivNameEl = root.querySelector('[data-jcb-voiv-name]');
    var clearBtn = root.querySelector('[data-jcb-clear]');
    var mapEl = root.querySelector('[data-jcb-map]');
    var labelsGroup = mapEl.querySelector('.jcb-map-labels');
    var i18nEl = root.querySelector('[data-jcb-i18n]');
    var I = i18nEl ? JSON.parse(i18nEl.textContent) : {};
    var VOIV = I.voiv || {};
    var VOIV_SHORT = I.voiv_short || {};
    var DAYS_PL = ['pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.', 'niedz.'];
    var DAYS = (I.days || '').split(',');

    var state = {
      data: null,
      voivedeship: null,
      query: ''
    };

    fetch(dataUrl)
      .then(function (r) { return r.json(); })
      .then(function (json) {
        state.data = json;
        renderLabels();
        attachMapHandlers();
        applyFilters();
      })
      .catch(function (err) {
        console.error('[JCB Map] Error loading data:', err);
        listEl.innerHTML = '<div class="jcb-locations__empty">' + escape(I.error) + '</div>';
      });

    /* ---------- Filtrowanie ---------- */

    function getFiltered() {
      if (!state.data) return [];
      var q = state.query.trim().toLowerCase();
      return state.data.locations.filter(function (loc) {
        if (state.voivedeship && loc.voivodeship !== state.voivedeship) return false;
        if (q) {
          var hay = (loc.name + ' ' + loc.city + ' ' + loc.postal + ' ' + loc.address).toLowerCase();
          if (hay.indexOf(q) === -1) return false;
        }
        return true;
      });
    }

    function applyFilters() {
      var items = getFiltered();
      // sortowanie alfabetyczne po nazwie
      items.sort(function (a, b) {
        return a.name.localeCompare(b.name, 'pl');
      });
      renderList(items);
      updateMapState();
      updateCounter(items.length);
      updateVoivStatus();
    }

    /* ---------- Render listy ---------- */

    function renderList(items) {
      if (items.length === 0) {
        listEl.innerHTML = '';
        emptyEl.hidden = false;
        return;
      }
      emptyEl.hidden = true;
      listEl.innerHTML = items.map(buildCard).join('');
    }

    function buildCard(loc) {
      var hoursRow = loc.hours ? row('clock', escape(localizeDays(loc.hours))) : '';
      var phoneClean = (loc.phone || '').replace(/\s+/g, '');
      var phoneRow = loc.phone
        ? row('phone', '<a href="tel:' + escape(phoneClean) + '">' + escape(loc.phone) + '</a>')
        : '';
      var emailRow = loc.email
        ? row('mail', '<a href="mailto:' + escape(loc.email) + '">' + escape(loc.email) + '</a>')
        : '';

      var fullAddress = loc.address + ', ' + loc.postal + ' ' + loc.city;
      var mapsUrl = 'https://www.google.com/maps?q=' +
                    encodeURIComponent(fullAddress);

      return ''
        + '<article class="jcb-loc-card" data-id="' + escape(loc.id) + '">'
        +   '<h3 class="jcb-loc-card__name">' + escape(loc.name) + '</h3>'
        +   '<div class="jcb-loc-card__rows">'
        +     row('pin', escape(fullAddress))
        +     phoneRow
        +     emailRow
        +     hoursRow
        +   '</div>'
        +   '<a class="jcb-loc-card__cta" href="' + mapsUrl + '" target="_blank" rel="noopener">'
        +     escape(I.cta)
        +     '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 5l7 7-7 7"/></svg>'
        +   '</a>'
        + '</article>';
    }

    function row(icon, content) {
      return '<div class="jcb-loc-row">' + ICONS[icon] + '<span>' + content + '</span></div>';
    }

    var ICONS = {
      pin:   '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>',
      phone: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/></svg>',
      mail:  '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>',
      clock: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12,6 12,12 16,14"/></svg>'
    };

    /* ---------- Mapa: stany i etykiety ---------- */

    function bringActivePathToFront() {
      // SVG renderuje w kolejności DOM - ostatni jest "na wierzchu".
      // Przenosimy aktywny path na koniec grupy regionów żeby jego stroke
      // nie był zasłaniany przez stroke'y sąsiednich województw.
      if (!state.voivedeship) return;
      var regionsGroup = mapEl.querySelector('.jcb-map-regions');
      var activePath = regionsGroup.querySelector('[data-voiv="' + state.voivedeship + '"]');
      if (activePath && regionsGroup.lastElementChild !== activePath) {
        regionsGroup.appendChild(activePath);
      }
    }

    function updateMapState() {
      var counts = countPerVoiv();
      mapEl.querySelectorAll('[data-voiv]').forEach(function (path) {
        var v = path.dataset.voiv;
        path.classList.toggle('is-active', v === state.voivedeship);
        path.classList.toggle('has-no-locations', !counts[v]);
        var label = VOIV[v] || state.data.voivodeships[v] || v;
        var count = counts[v] || 0;
        path.setAttribute('aria-label', label + ': ' + fill(pluralForm('region', count), count));
      });
    }

    function countPerVoiv() {
      var out = {};
      if (!state.data) return out;
      var q = state.query.trim().toLowerCase();
      state.data.locations.forEach(function (loc) {
        if (q) {
          var hay = (loc.name + ' ' + loc.city + ' ' + loc.postal + ' ' + loc.address).toLowerCase();
          if (hay.indexOf(q) === -1) return;
        }
        out[loc.voivodeship] = (out[loc.voivodeship] || 0) + 1;
      });
      return out;
    }

    function renderLabels() {
      labelsGroup.innerHTML = '';
      Object.keys(LABEL_POSITIONS).forEach(function (voiv) {
        var pos = LABEL_POSITIONS[voiv];
        var name = document.createElementNS(SVG_NS, 'text');
        name.setAttribute('x', pos.x);
        name.setAttribute('y', pos.y);
        name.setAttribute('class', 'label-name');
        name.dataset.voiv = voiv;
        name.textContent = VOIV_SHORT[voiv] || VOIV[voiv] || pos.name;
        labelsGroup.appendChild(name);
      });
    }

    /* ---------- Eventy ---------- */

    function attachMapHandlers() {
      mapEl.addEventListener('click', function (e) {
        var path = e.target.closest('[data-voiv]');
        if (!path) return;
        if (path.classList.contains('has-no-locations')) return;
        var v = path.dataset.voiv;
        state.voivedeship = state.voivedeship === v ? null : v;
        if (hintEl) hintEl.classList.add('is-hidden');
        applyFilters();
        bringActivePathToFront();
      });

      mapEl.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var path = e.target.closest('[data-voiv]');
        if (!path) return;
        e.preventDefault();
        path.click();
      });

      mapEl.querySelectorAll('[data-voiv]').forEach(function (p) {
        p.setAttribute('tabindex', '0');
        p.setAttribute('role', 'button');
      });

      searchEl.addEventListener('input', debounce(function () {
        state.query = searchEl.value;
        applyFilters();
      }, 150));

      clearBtn.addEventListener('click', function () {
        state.voivedeship = null;
        applyFilters();
      });
    }

    function updateCounter(visibleCount) {
      var total = state.data ? state.data.locations.length : 0;
      if (visibleCount === total) {
        totalEl.textContent = fill(pluralForm('total', total), total);
      } else {
        totalEl.textContent = fill(I.shown, visibleCount, total);
      }
    }

    function updateVoivStatus() {
      if (state.voivedeship) {
        voivStatusEl.hidden = false;
        voivNameEl.textContent = I.voiv_status.replace('[name]', VOIV[state.voivedeship] || state.data.voivodeships[state.voivedeship] || state.voivedeship);
      } else {
        voivStatusEl.hidden = true;
      }
    }

    /* ---------- helpers ---------- */

    function escape(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function pluralForm(prefix, n) {
      var form = new Intl.PluralRules(I.locale).select(n);
      return I[prefix + '_' + form] || I[prefix + '_many'];
    }

    function fill(s, n, total) {
      return String(s).replace('[n]', n).replace('[total]', total);
    }

    function localizeDays(s) {
      return String(s).replace(/pon\.|wt\.|śr\.|czw\.|pt\.|sob\.|niedz\./g, function (m) {
        return DAYS[DAYS_PL.indexOf(m)] || m;
      });
    }

    function debounce(fn, ms) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, ms);
      };
    }
  }

  /* ---------- bootstrap ---------- */

  function bootstrap() {
    document.querySelectorAll('[data-jcb-locations]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Shopify theme editor support
  document.addEventListener('shopify:section:load', bootstrap);
})();